export default function InfoIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' className='w-8 h-8' viewBox='0 0 32 32'>
      <g fill='none' stroke='currentColor'>
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M15 14h1v9h1m12-7a13 13 0 1 1-26 0a13 13 0 0 1 26 0Z'
        />
        <path fill='currentColor' d='M17 9.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z' />
      </g>
    </svg>
  )
}
